import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import LoginPage from "@/pages/login/page";
import DashboardPage from "@/pages/dashboard/page";
import ProductosPage from "@/pages/productos/page";
import ReportesPage from "@/pages/reportes/page";
import VentasPage from "@/pages/ventas/page";
import UsuariosPage from "@/pages/usuarios/page";
import ConfiguracionPage from "@/pages/configuracion/page";
import AdminLayout from "@/components/feature/AdminLayout";
import ProtectedRoute from "@/components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "productos",
        element: <ProductosPage />,
      },
      {
        path: "ventas",
        element: <VentasPage />,
      },
      {
        path: "reportes",
        element: <ReportesPage />,
      },
      {
        path: "usuarios",
        element: (
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <UsuariosPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "configuracion",
        element: (
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <ConfiguracionPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;